module.exports = __webpack_public_path__ + "img/swiper_5.ae234e17.jpg";